export default __webpack_public_path__ + "static/media/mario.ac792383.jpg";